export default "<p>fgroup works!</p>\n";